import { Link } from "react-router-dom";
import { Mail, ChevronsRight } from "lucide-react";
import PageHero from "../components/PageHero";
import useReveal from "../hooks/useReveal";
import { TEAM, SITE } from "../mock";

export default function Team() {
  useReveal();
  return (
    <>
      <PageHero
        eyebrow="Who We Are"
        title="Meet the team behind EnviroJusticePR"
        subtitle="A youth-led 501(c)3 environmental conservation organization. Our leadership and advisory board bring together passion for sustainability, water access and community-driven change in Puerto Rico."
      />
      {["Leadership", "Advisory Board"].map((group, gi) => (
        <section key={group} className={gi % 2 === 0 ? "bg-white" : "bg-[#F8F7F0]"}>
          <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-20">
            <div className="reveal mb-16 flex items-center gap-5">
              <h2 className="text-3xl md:text-4xl font-extrabold whitespace-nowrap">{group}</h2>
              <span className="h-px flex-1 bg-[#e4e2d6]" />
            </div>
            <div className="space-y-24">
              {TEAM.filter((m) => m.group === group).map((m, i) => (
                <div key={m.id} className="reveal grid lg:grid-cols-5 gap-12 lg:gap-16 items-center">
                  <div className={`relative group lg:col-span-2 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                    <div className={`absolute -inset-4 rounded-2xl bg-[#4BAF47]/10 ${i % 2 === 1 ? "-rotate-2" : "rotate-2"} transition-transform duration-500 group-hover:rotate-0`} />
                    <div className="relative rounded-xl overflow-hidden aspect-[4/5] max-w-[440px] mx-auto shadow-[0_40px_80px_-30px_rgba(36,35,29,0.35)] bg-[#e9e8e1]">
                      <img src={m.image} alt={m.name} className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    </div>
                  </div>
                  <div className={`lg:col-span-3 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                    <p className="eyebrow mb-4">{m.role}</p>
                    <h3 className="section-title">{m.name}</h3>
                    <div className="mt-6 space-y-4">
                      {m.bio.map((p, k) => (
                        <p key={k} className="text-[#878680] text-lg leading-relaxed">{p}</p>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="leaf-bg">
        <div className="max-w-[1320px] mx-auto px-5 lg:px-8 py-20 grid lg:grid-cols-2 gap-10 items-center">
          <div className="reveal">
            <p className="eyebrow mb-4">Join us</p>
            <h2 className="section-title">Want to volunteer or collaborate?</h2>
            <p className="text-[#878680] text-lg mt-5 leading-relaxed">We are always looking for community partners, translators, writers and developers. Reach out and let's build a greener Puerto Rico together.</p>
          </div>
          <div className="reveal flex flex-wrap gap-4 lg:justify-end">
            <a href={`mailto:${SITE.email}`} className="btn-green"><Mail size={16} /> {SITE.email}</a>
            <Link to="/tell-your-story" className="btn-outline">Tell Your Story <ChevronsRight size={16} /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
